// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2jnws","image":"Header_image__bznMT","name":"Header_name__2fI7w","info":"Header_info__1LEHn","infoRow":"Header_infoRow__2F_MU"};